import { render } from "./JoinUsJoiningForm.vue?vue&type=template&id=2ebaa2dc"
const script = {}

import exportComponent from "/home/fluffypony/Projects/tai-g-damn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__